<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load DCA tickets"
    data-testid="warrants-dca-tickets"
    searchable
    search-placeholder="Search account number"
    :filters="warrantsDcaTicketsTableFilters"
    :fetcher="fetchTickets"
    :items-from="itemsFrom"
  >
    <template #[`item.status`]="{ internalItem }">
      <SoChip :text="internalItem.raw.statusDisplay" size="small" />
    </template>
  </WarrantsDataTableTab>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import {
    accountNumberColumn,
    createdAtColumn,
    deletedColumn,
    idColumn,
    statusColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsDcaTicketListResult,
    WarrantsDcaTicketService,
  } from "@/services/admin/WarrantsDcaTicketService"
  import {
    warrantsDcaTicketsTableFilters,
    WarrantsDcaTicketsTableFilters,
  } from "@/views/admin/warrants/warrantsDcaTicketsConfig"

  const headers: SoDataTableHeader[] = [
    idColumn,
    accountNumberColumn,
    { title: "Type", key: "typeDisplay", sortable: true, sortKey: "type" },
    {
      title: "DCA Type",
      key: "dcaTypeDisplay",
      sortable: true,
      sortKey: "dca_type",
    },
    statusColumn,
    {
      title: "Ticket ID",
      key: "ticketId",
      sortable: true,
      sortKey: "ticket_id",
      fallbackValue: "—",
    },
    {
      title: "Ticket Step",
      key: "ticketStep",
      sortable: false,
      fallbackValue: "—",
    },
    {
      title: "Ticket Definition",
      key: "ticketDefinition",
      sortable: false,
      fallbackValue: "—",
    },
    createdAtColumn,
    deletedColumn,
  ]

  export default defineComponent({
    components: {
      SoChip,
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
        warrantsDcaTicketsTableFilters,
      }
    },
    methods: {
      fetchTickets({
        search,
        filters,
        page,
        pageSize,
        orderBy,
      }: SoDataTableOptions<WarrantsDcaTicketsTableFilters>) {
        return WarrantsDcaTicketService.getTickets(
          search,
          {
            status: filters.status.value,
            type: filters.type.value,
            dcaType: filters.dcaType.value,
          },
          page,
          pageSize,
          orderBy,
        )
      },
      itemsFrom(result: WarrantsDcaTicketListResult) {
        return result.tickets
      },
    },
  })
</script>
